import React from 'react'
import { Route, IndexRoute, browserHistory } from 'react-router'
import { api } from './config'

import App from './components/App'

import ProfileCreate from './containers/ProfileCreate'
import ProfileSignup from './containers/ProfileSignup'
import ProfileSignupParams from './containers/ProfileSignupParams'
import SeasonSignupParams from './containers/SeasonSignupParams'
import PartnerLogin from './containers/PartnerLogin'
import PartnerDataShow from './containers/PartnerDataShow'
import ProfilePasswordForget from './containers/ProfilePasswordForget'
import ProfilePasswordRestore from './containers/ProfilePasswordRestore'
import ProfilePay from './containers/ProfilePay'
import TomorrowFriend from './components/profile/TomorrowFriend'
import LoginSocial from './components/profile/LoginSocial'
import LoginFB from './components/profile/LoginFB'
import LoginOk from './components/profile/LoginOk'
import NotFound from './components/profile/NotFound'
import SuccessProfile from './components/profile/SuccessProfile'
import DayEditor from './components/admin/DayEditor'
import FoodEditor from './components/admin/FoodEditor'
import PhotosIntro from './components/admin/PhotosIntro'
import PhotosIntroWoman from './components/admin/PhotosIntroWoman'
import AdminLogin from './containers/AdminLogin'
import Seasons from './containers/Seasons'
import ErrorReport from './containers/ErrorReport'
import Partners from './components/partner/Partners'
import PartnerItem from './components/partner/PartnerItem'
// Minion containers

import MinionLogin from './containers/MinionLogin'

import PendingMinionChats from './containers/PendingMinionChats'

import PendingPhoto from './containers/PendingPhoto'
import PendingPhotos from './containers/PendingPhotos'

import PendingMinionEvent from './containers/PendingMinionEvent'
import PendingMinionEvents from './containers/PendingMinionEvents'

import PendingProfile from './containers/PendingProfile'
import PendingProfiles from './containers/PendingProfiles'

import PendingInsuranceProfile from './containers/PendingInsuranceProfile'
import PendingInsuranceProfiles from './containers/PendingInsuranceProfiles'
import TodayTask from './containers/TodayTask'
import Reports from './containers/Reports'
import Faq from './components/Faq'
import Food from './containers/Food'
import Photos from './containers/Photos'
import ChatPage from './containers/ChatPage'

import cookie from 'react-cookie'
import { promoWatch } from './actions/promo/promoWatch'
import { setHost, getSiteSettings } from './actions'

export const getRoutes = (store) => {

const leave = () => {
  cookie.remove('token', { path: '/' })
  cookie.remove('txId', { path: '/' })
  cookie.remove('role', { path: '/' })
  cookie.remove('program', { path: '/' })
  cookie.remove('packageType', { path: '/' })
  cookie.remove('promoName', { path: '/' })
  cookie.remove('share', { path: '/' })
  cookie.remove('general', { path: '/' })
  cookie.remove('tester', { path: '/' })
  cookie.remove('abtest',{ path: '/' })
  browserHistory.push('/')
}

const getRole = (role) => {
  const token = cookie.load('token')
  const pathname = store.getState().routing.locationBeforeTransitions.pathname,
        pathnameArr = pathname.split('/')

  if(pathnameArr[2] === 'photosWoman'){
    store.dispatch({
      type: 'SELECT_PHOTO_FAQ',
      value:'UserPhotoCaptionWoman'
    })
  }

  if (token) {
    return fetch(`${api}/user/user-get`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify({
        authToken: token,
        data: {}
      })
      })
      .then(response => response.json())
      .then(json => {
        const isRegistered = !(!json || json.errorCode !== 1 || !json.data || !json.data[0] || json.data[0].role !== role)

        if (isRegistered) {
          cookie.save('user_id', json.data[0].id, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 }) // id текущего пользователя необходим для чатов

          if (role === 3 && json.data[0].paidState === 0) {
            browserHistory.push('/signup/pay')
          }
        } else {
          browserHistory.push(role === 2 ? '/userReports' : '/')
        }
      })
    } else {
      leave()
    }
  }

  const defineHost = (storeLocal) => {
    //console.log(window.location)
    //console.log('defineDomenn')
    const hostname = window.location.hostname.split('.')[0]
    //console.log(hostname )
    store.dispatch(setHost(hostname))
  }

  const enterSignup = () => {
    defineHost()
    userGet()
  }
  const siteSettings = () => {
    return fetch(`${api}/data/siteSettings-get`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify({})
    })
      .then(response => response.json())
      .then(json => {
        console.log('getSiteSettings')
        console.log(json)
        if(json.errorCode === 1){
          store.dispatch(getSiteSettings(json.data))
        }
      })
  }

  const userGet = () => {
    const token = cookie.load('token')
    console.log('tokennnnnn')
    console.log(token)
    if(!token){
      return;
    }
    return fetch(`${api}/user/user-get`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify({
        authToken: token,
        data: {}
      })
    })
      .then(response => response.json())
      .then(json => {
        console.log('userGEttttttt')
        console.log(json)
       let data = json.data[0]
        store.dispatch({
          type: 'USER_INFO',
          data
        })
      })
  }

//paidState = 0 ничего не куплено
  //paidState = -1 куплен предыдущий сезон
  //paidState = 1 куплен текущий сезон
  //paidState = 4 истек понедельный тариф

  const requirePayAuth = fromPay => {
    const token = cookie.load('token')
    const random  = Math.random()
    if (token) {
      return fetch(`${api}/user/user-get`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({
          authToken: token,
          data: {}
        })
      })
      .then(response => response.json())
      .then(json => {
        console.log(json)
        console.log('enterrr')
        if (json && json.errorCode === 1 && json.data && json.data[0]) {
          if (json.data[0].paidState !== 0 && json.data[0].paidState !== 4 && json.data[0].program % 4 !== 0) {
            cookie.save('userProgram', json.data[0].program, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
            cookie.save('fullName', json.data[0].firstName + ' ' + json.data[0].lastName, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
            cookie.save('email', json.data[0].email, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
            if (json.data[0].paidState === 2) {
              browserHistory.push('/signup/pay/success')
            } else if (json.data[0].isFirstEdit) {
              browserHistory.push('/profile')
            } else {
              console.log('taskkkk')
              browserHistory.push('/task')// browserHistory.push('/signup/pay/success')
            }
          } else if (json.data[0].paidState !== 0 && (json.data[0].program === 16 || json.data[0].program === 8 || json.data[0].program === 12)) {
            browserHistory.push('/signup/pay/friend?simple=true')
          //} else if (!json.data[0].program) {
            //console.log('???????????????')
            //browserHistory.push('/signup/params')
          } else {
            console.log('payyyy')
            browserHistory.push('/signup/pay')
          }
        } else {
          leave()
        }
      })
    } else if (fromPay) {
      browserHistory.push('/')
    }
  }

  const requirePayNewSeasonAuth = fromPay => {
    const token = cookie.load('token')
    if (token) {
      return fetch(`${api}/user/user-get`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({
          authToken: token,
          data: {}
        })
      })
      .then(response => response.json())
      .then(json => {
        if (json && json.errorCode === 1 && json.data && json.data[0]) {
          if (json.data[0].paidState !== 0 && json.data[0].program + '' !== '4' && json.data[0].program + '' !== '8' && json.data[0].program + '' !== '12') {
            cookie.save('userProgram', json.data[0].program, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
            cookie.save('fullName', json.data[0].firstName + ' ' + json.data[0].lastName, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })

            if (json.data[0].paidState === 1 || json.data[0].paidState === -1) {

              browserHistory.push('/season/pay')
            } else if (json.data[0].paidState === 2) {
              browserHistory.push('/signup/pay/success')
            } else if (json.data[0].isFirstEdit) {
              browserHistory.push('/profile')
            } else {
              browserHistory.push('/task')// browserHistory.push('/signup/pay/success')
            }
          } else if (json.data[0].paidState !== 0 && (json.data[0].program === 16 || json.data[0].program === 8 || json.data[0].program === 12)) {
            browserHistory.push('/signup/pay/friend?simple=true')
          } else {
            browserHistory.push('/signup/pay')
          }
        } else {
          leave()
        }
      })
    } else if (fromPay) {
      leave()
    }
  }

  const pushSubscriberSend = () =>{
    const token = cookie.load('token'),
          pushId = cookie.load('wingify_push_subscriber_id')

    if (token && pushId) {
      return fetch(`${api}/user/push4site-adduser`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({
          authToken: token,
          data: pushId
        })
      })
        .then(response => response.json())
        .then(json => {
        })
      }
    }


  const requireForTest = () => {
    const token = cookie.load('token')

    pushSubscriberSend()
    defineHost()
    if (token) {
      return fetch(`${api}/user/user-get`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({
          authToken: token,
          data: {}
        })
      })
      .then(response => response.json())
      .then(json => {
        console.log('reg-test')
        console.log(json)
        const data = json.data[0]
        const isRegistered = json && json.errorCode === 1 && json.data && json.data[0]
        if (!isRegistered) {
          browserHistory.push('/')
        } else {
          if (json.data[0].paidState === 2) {
            browserHistory.push('/signup/pay/success')
          }
          store.dispatch({
            type:'USER_INFO',
            data
          })
          cookie.save('userPaidState', json.data[0].paidState, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
          cookie.save('userProgram', json.data[0].program, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
          cookie.save('fullName', json.data[0].firstName + ' ' + json.data[0].lastName, { path: '/', maxAge: 60 * 60 * 24 * 365 * 10 })
        }

      })
    } else {
      leave()
    }
  }

  const requireProgram = () => {
    defineHost()
    const token = cookie.load('token')
    if (token) {
      return fetch(`${api}/user/user-get`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({
          authToken: token,
          data: {}
        })
      })
      .then(response => response.json())
      .then(json => {
        const isRegistered = json && json.errorCode === 1 && json.data && json.data[0]
        if (!isRegistered && (json.data[0].program === 16 && (json.data[0].program === 8 || json.data[0].program === 12))) {
          browserHistory.push('/signup/pay/friend?simple=true')
        } else if (isRegistered && json.data[0].paidState === 3) {
          browserHistory.push('/task')
        }
      })
    } else {
      leave()
    }
  }

  const requireEverytime = () => {
    promoWatch()
    defineHost()
    siteSettings()
  }


  const requireMinionAuth = () => getRole(2)
  const requireAdminAuth = () => getRole(1)
  const requireFromPayAuth = () => requirePayAuth(true)
  const requireFromPayNewSeasonAuth = () => requirePayNewSeasonAuth(true)
  const requireFromLoginAuth = () => requirePayAuth(false)


  const isABTest = (storeLocal) => {

    const random = Math.random()
    let host = window.location.hostname.split('.')[0]
    const pathname = storeLocal.location.pathname,
          pathnameArr = pathname.split('/')
    if(storeLocal.location.query.type){
      store.dispatch({ type: 'CHOOSEN_PACKAGE_TYPE', choosenPackageType: storeLocal.location.query.type })
    }
    if(host === 'alfa'){ // отмена аб тестов для альфы и других
      //console.log('window.location.hostnameeee')
      //console.log(window.location.hostname)
      return
    }
    if (pathname.slice(-2) === '/a') return
    if (random < 0.5 && storeLocal.location.query.type !== '4' && pathnameArr[2] !== 'tele2') {
      cookie.save('abtest', 'test', { path: '/' })
      browserHistory.push(pathname + '/a')
    } else {
      cookie.remove('abtest',{ path: '/' })
    }
    requireFromLoginAuth()
  }

  return (
    <Route path='/' onEnter={requireEverytime}>
      <IndexRoute component={App} onEnter={requireFromLoginAuth}/>
      <Route path='task' component={TodayTask} onEnter={requireForTest}/>
      <Route path='task/:id' component={TodayTask} onEnter={requireForTest}/>
      <Route path='faq' component={Faq} onEnter={requireForTest}/>
      <Route path='food' component={Food} onEnter={requireForTest}/>
      <Route path='reports' component={Reports} onEnter={requireForTest}/>
      <Route path='photos' component={Photos} onEnter={requireForTest}/>
      <Route path='chats/:id' component={ChatPage} onEnter={requireForTest}/>
      <Route path='seasons' component={Seasons} onEnter={requireForTest}/>
      <Route path='error-report' component={ErrorReport} onEnter={requireForTest}/>
      <Route path='partners' component={Partners} onEnter={requireForTest} />
      <Route path='partners/:name' component={PartnerItem} onEnter={requireForTest}/>
      <Route path='profile' component={ProfileCreate} onEnter={requireForTest}/>
      <Route path='social/gp' component={LoginSocial}/>
      <Route path='social/vk' component={LoginSocial}/>
      <Route path='social/in' component={LoginSocial}/>
      <Route path='social/fb' component={LoginFB}/>
      <Route path='social/ok' component={LoginOk}/>
      <Route path='season' component={SeasonSignupParams}/>
      <Route path='season/pay' component={ProfilePay} onEnter={requireFromPayNewSeasonAuth}/>
      <Route path='signup' onEnter={enterSignup}>
        <IndexRoute component={ProfileSignup} onEnter={isABTest} />
        <Route path='params' component={ProfileSignupParams} />
        <Route path='pay' component={ProfilePay} onEnter={requireFromPayAuth} />
        <Route path='pay/friend' component={TomorrowFriend} />
        <Route path='pay/success' component={SuccessProfile} onEnter={requireProgram} />
      </Route>
      <Route path='signup/:program' component={ProfileSignup} onEnter={isABTest}/>
      <Route path='signup/:program/a' component={ProfileSignup} onEnter={requireFromLoginAuth}/>
      <Route path='restore'>
        <IndexRoute component={ProfilePasswordForget} onEnter={requireFromLoginAuth}/>
        <Route path='create' component={ProfilePasswordRestore} onEnter={requireFromLoginAuth}/>
      </Route>
      <Route path='partner'>
        <IndexRoute component={PartnerLogin}/>
        <Route path='show' component={PartnerDataShow} onEnter={requireAdminAuth}/>
      </Route>
      <Route path='userReports'>
        <IndexRoute
          component={MinionLogin}/>

        <Route
          path='chats'
          component={PendingMinionChats}
          onEnter={requireMinionAuth}/>

        <Route
          path='exams'
          component={PendingMinionEvents}
          onEnter={requireMinionAuth}/>
        <Route
          path='exams/:userId/:dayId'
          component={PendingMinionEvent}
          onEnter={requireMinionAuth}/>

        <Route
          path='pendingProfiles'
          component={PendingProfiles}
          onEnter={requireMinionAuth}/>
        <Route
          path='pendingProfiles/:userId'
          component={PendingProfile}
          onEnter={requireMinionAuth}/>

        <Route
          path='photos'
          component={PendingPhotos}
          onEnter={requireMinionAuth}/>
        <Route
          path='photos/:userId/:season'
          component={PendingPhoto}
          onEnter={requireMinionAuth}/>

        <Route
          path='pendingInsurance'
          component={PendingInsuranceProfiles}
          onEnter={requireMinionAuth}/>
        <Route
          path='pendingInsurance/:userId/:insuranceId'
          component={PendingInsuranceProfile}
          onEnter={requireMinionAuth}/>
      </Route>

      <Route path='superadmin'>
        <IndexRoute component={AdminLogin}/>
        <Route path='day' component={DayEditor} onEnter={requireMinionAuth}/>
        <Route path='day/:program' component={DayEditor} onEnter={requireMinionAuth}/>
        <Route path='day/:program/:id' component={DayEditor} onEnter={requireMinionAuth}/>
        <Route path='food' component={FoodEditor} onEnter={requireMinionAuth}/>
        <Route path='photos' component={PhotosIntro} onEnter={requireMinionAuth}/>
        <Route path='photosWoman' component={PhotosIntroWoman} onEnter={requireMinionAuth}/>
      </Route>

      <Route path="*" component={NotFound}/>
    </Route>
  )
}



// WEBPACK FOOTER //
// /var/www/build-lk-1/src/routes.js